import { Button, Form, Input } from '@bancobarigui/barihaus';

import { ResetPasswordParams } from '../useResetPassword';

type Props = {
  onFinish: ({ password, confirm }: ResetPasswordParams) => void;
  loading?: boolean;
};

export function ResetPasswordForm({ onFinish, loading }: Props) {
  return (
    <>
      <Form name="changePassword" onFinish={onFinish}>
        <Form.Item name="password" rules={[{ required: true, message: 'Digite sua nova senha' }]}>
          <Input placeholder="Sua nova senha" type='password' />
        </Form.Item>

        <Form.Item
          name="confirm"
          rules={[
            { required: true, message: 'Confirme sua senha' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('As duas senhas que você digitou não são iguais!'));
              },
            }),
          ]}
        >
          <Input placeholder="Confirme sua nova senha" type='password'/>
        </Form.Item>

        <Form.Item>
          <Button
            block
            htmlType="submit"
            loading={loading}
            disabled={loading}
            className="!h-12 !rounded-xl !text-base !font-semibold !border-0 !bg-[#0090ff] hover:!bg-[#0077d5] !text-white disabled:!bg-[#0090ff] disabled:!text-white disabled:!opacity-80"
          >
            {loading ? 'Salvando...' : 'Confirmar'}
          </Button>
        </Form.Item>
               <div className="text-[12px] text-gray-500 mb-3 -mt-2 px-1 leading-tight">
          <span className="block mb-0.5">A senha deve incluir:</span>
          <ul className="list-disc list-inside space-y-0">
            <li>Mínimo 8 caracteres</li>
            <li>1 minúscula e 1 maiúscula</li>
            <li>1 número e 1 caractere especial</li>
          </ul>
        </div>
      </Form>
    </>
  );
}
